import {
  createBrowserRouter,
  createRoutesFromElements,
  Navigate,
  Route,
} from "react-router-dom";
import AnonymousUserLayout from "../components/layout/anonymousUserLayout/AnonymousUserLayout";
import RoutesString, {
  NotFound,
  // TermAndConditions,
  Login,
  Dashboard,
  StylesGuide,
  TransferByAccount,
  TransferByBatch,
  TransferByCard,
  TransferByPhone,
  CardTransactionList,
  TransactionList,
  TransactionDetail,
  BeneficiaryTemplate,
  AccountsList,
  // AccountDetail,
  TransactionHistory,
  BillPayment,
  BillPaymentList,
  CardList,
  CardTransactionHistoryPage,
  CardTransactionDetailPage,
  CardLimitSettingPage,
  CreditCardStatementPage,
  CreditCardStatementViewPage,
  CreditCardPaymentPage,
  CreditCardPaymentConfirmPage,
  CardUnlockPage,
  CardLockPage,
  CardOnlinePaymentPage,
  CardActionResultPage,
  Notfications,
  Setting,
  ForgotPassword,
  TermDepositDetail,
  FinalizeDeposit,
  FinalizeDepositDetail,
  WithdrawAccount,
  RootWithdrawal,
  WithdrawAccountResponse,
  ApproveFinalSettlement,
  ApproveFinalSettlementResponse,
  TransactionResponse,
  Disbursement,
  AddDisbursement,
  DisbursementDetail,
  LoanManagementList,
  LoanManagementDetail,
  LoanManagementClosure,
  LoanManagementPayment,
  ForeignCurrencyExchangePage,
  DomesticTaxPaymentPage,
  CustomsDutyPaymentPage,
  SellForeignCurrencyPage,
  LetterOfCreditPage,
  ShippingDocumentsPage,
  GuaranteePage,
  LetterOfCreditDetailPage,
  ShippingDocumentsDetail,
  GuaranteeDetailPage,
  GuaranteeIssuancePage,
  GuaranteeListAw122Page,
  GuaranteeRequestDetailPage,
  GuaranteeApprovalListPage,
  GuaranteeApprovePage,
  GuaranteeLetterDetailPage,
  GuaranteeIssueStep1Page,
  GuaranteeIssueStep2Page,
  GuaranteeIssueStep3Page,
  GuaranteeIssueStep4Page,
  GuaranteeIssueResultPage,
  GuaranteeSupplementPage,
  RegistartionFreePage,
  NopNsnnOverviewPage,
  MortgageLoanAccountPage,
  ConvenienceServicesPage,
  BookingList,
  UserManagementPage,
  RequirementsManagementPage,
  LetterOfCreditOpenedPage,
  LetterOfCreditOnlinePage,
  InfoBusinessPage,
  PermissionManagementPage,
  TermDepositListPage,
  TransHistoryDetailPage,
  PartialWithdrawalPage,
  OnboardingPage,
  CorpOnboardingPage,
  ForceChangePasswordPage,
  HkdAccountsPage,
  HkdTransferPage,
  HkdQrPaymentPage,
  HkdEInvoicePage,
  HkdReportPage,
  HkdLoaPage,
  HkdPackagePage,
  HkdDomesticTaxPage,
  HkdRegistrationFeePage,
  // UserProfile,
  // CurrentLimit,
  // ChangePassword,
  // DeviceManagement,
  // NotificationSettings,
  // About,
  // TermsAndConditions,
  // OpenCurrentAccount,
} from "./routesString";
import PrivateRoute from "./privateRoute";
import CardDetail from "./cards/card-detail.tsx/CardDetail";
import AuthLayout from "../components/layout/auth-layout/AuthLayout";
import TermAndCondition from "./term-deposit/TermDeposit";
import TermLoan from "./term-loan/TermLoan";
// import { TermLoanDetail } from "modules/term-loan/components/TermLoanDetail";
import { LoanSettlement } from "modules/term-loan/components/LoanSettlement";
import TermDepositSettlement from "./term-loan/TermDepositSettlement";
import TermLoanSettlementResponse from "modules/term-loan/TermLoanSettlementResponse";
import CurrentAccountPanelDetail from "@/modules/accounts/components/detail-current-account-panel/CurrentAccountPanelDetail";
import DepositAccountPanelDetail from "@/modules/accounts/components/detail-deposit-account-panel/DepositAccountPanelDetail";
import LoanAccountPanelDetail from "@/modules/accounts/components/detail-loan-account-panel/LoanAccountPanelDetail";
import TransInternational from "./transfer-money/transfer-international/TransInternational";
import TransInterDetailPreview from "./transfer-money/transfer-international/TransInterDetailPreview";
import PreLogin from "./login/PreLogin";
import SupportPage from "./login/SupportPage";
import TermDepositDetailPage from "./savings/TermDepositDetailPage";
import LockDetail from "./accounts/accounts-detail/LockDetail";
import ApprovelLockAccountChecker from "@/modules/manage-transaction/transaction-detail/component/lock-account/ApproveLockAccountChecker";
import SavingListPage from "./savings/SavingListPage";
import DepositSettlementPage from "./deposit-settlement/DepositSettlementPage";
import DepositTopupPage from "./deposit-topup/DepositTopupPage";
// import ChatPage from "./chat/ChatPage";
// import useAuthentication from "stores/AuthenticationStore/authentication";

const GuardedRequirementsManagement = RequirementsManagementPage;
const GuardedUserManagement = UserManagementPage;
const GuardedInfoBusiness = InfoBusinessPage;
const GuardedPermissionManagement = PermissionManagementPage;

const router = createBrowserRouter(
  // const [{ user }] = useAuthentication();
  createRoutesFromElements(
    <>
      <Route element={<AnonymousUserLayout />}>
        <Route path={RoutesString.StylesGuide} element={<StylesGuide />} />
        <Route path={RoutesString.PreLogin} element={<PreLogin />} />
        <Route path={RoutesString.Support} element={<SupportPage />} />
        <Route element={<AuthLayout />}>
          <Route path={RoutesString.Login} element={<Login />} />
          <Route
            path={RoutesString.Forgotpassword}
            element={<ForgotPassword />}
          />
          <Route
            path={RoutesString.ForceChangePassword}
            element={<ForceChangePasswordPage />}
          />
        </Route>
        <Route
          path={RoutesString.Onboarding}
          element={<OnboardingPage />}
        />
        <Route
          path={RoutesString.CorpOnboarding}
          element={<CorpOnboardingPage />}
        />

        {/* OTHER */}
        <Route path={RoutesString.NotFound} element={<NotFound />} />
        <Route
          path="*"
          element={<Navigate replace to={RoutesString.NotFound} />}
        />
      </Route>
      <Route element={<PrivateRoute />}>
        {/* DASHBOARD */}
        <Route path={RoutesString.Dashboard} element={<Dashboard />} />

        {/* HKD (MERCHANT) pages */}
        <Route path={RoutesString.HkdAccounts} element={<HkdAccountsPage />} />
        <Route path={RoutesString.HkdTransfer} element={<HkdTransferPage />} />
        <Route path={RoutesString.HkdQrPayment} element={<HkdQrPaymentPage />} />
        <Route path={RoutesString.HkdEInvoice} element={<HkdEInvoicePage />} />
        <Route path={RoutesString.HkdReport} element={<HkdReportPage />} />
        <Route path={RoutesString.HkdLoa} element={<HkdLoaPage />} />
        <Route path={RoutesString.HkdPackage} element={<HkdPackagePage />} />
        <Route path={RoutesString.HkdDomesticTax} element={<HkdDomesticTaxPage />} />
        <Route path={RoutesString.HkdRegistrationFee} element={<HkdRegistrationFeePage />} />
        {/* SETTING */}
        <Route
          path={`${RoutesString.Setting}/:tab?/:subTab?/:childTab?`}
          element={<Setting />}
        />
        {/* <Route path={RoutesString.UserProfile} element={<UserProfile />} /> */}
        {/* <Route
          path={RoutesString.ChangePassword}
          element={<ChangePassword username={user?.userName} />}
        /> */}
        {/* <Route
          path={`${RoutesString.CurrentLimit}`}
          element={<CurrentLimit />}
        />
        <Route
          path={RoutesString.DeviceManager}
          element={<DeviceManagement />}
        />
        <Route
          path={RoutesString.NotificationSettings}
          element={<NotificationSettings />}
        />
        <Route path={RoutesString.About} element={<About />} />
        <Route
          path={RoutesString.TermsAndConditions}
          element={<TermsAndConditions />}
        />
        <Route
          path={RoutesString.OpenCurrentAccount}
          element={<OpenCurrentAccount />}
        /> */}
        {/* TRANSFER MONEY */}
        <Route
          path={RoutesString.TransferByPhone}
          element={<TransferByPhone />}
        />
        <Route
          path={RoutesString.TransferByAccount}
          element={<TransferByAccount />}
        />
        <Route
          path={RoutesString.TransferByCard}
          element={<TransferByCard />}
        />
        <Route
          path={RoutesString.TransferByBatch}
          element={<TransferByBatch />}
        />
        <Route
          path={RoutesString.TransInternational}
          element={<TransInternational />}
        />
        {/* PREVIEW TẠM — xem màn chi tiết CTQT không cần API (xoá khi ghép API) */}
        <Route
          path="/preview/ctqt-detail"
          element={<TransInterDetailPreview />}
        />
        {/* MANAGE TRANSACTION */}
        <Route
          path={RoutesString.TransactionList}
          element={<TransactionList />}
        />
        <Route
          path={RoutesString.TransactionHistory}
          element={<TransactionHistory />}
        />
        <Route
          path={`${RoutesString.TransactionDetail}/:encryptedCode`}
          element={<TransactionDetail />}
        />
        <Route
          path={`${RoutesString.TransactionHistory}/:encryptedCode`}
          element={<TransactionHistory />}
        />
        <Route
          path={`${RoutesString.TransactionResponse}/:encryptedCode`}
          element={<TransactionResponse />}
        />
        <Route
          path={RoutesString.CardTransactionList}
          element={<CardTransactionList />}
        />
        <Route
          path={RoutesString.BeneficiaryTemplate}
          element={<BeneficiaryTemplate />}
        />
        {/* ACCOUNTS */}
        <Route path={RoutesString.AccountsList} element={<AccountsList />} />
        <Route path={RoutesString.CardsDetailWithId} element={<CardDetail />} />
        <Route
          path={RoutesString.CardsCreditDetailWithId}
          element={<CardDetail />}
        />
        <Route
          path={RoutesString.CardTransactionHistoryWithId}
          element={<CardTransactionHistoryPage />}
        />
        <Route
          path={RoutesString.CardTransactionHistory}
          element={<CardTransactionHistoryPage />}
        />
        <Route
          path={RoutesString.CardTransactionDetailWithId}
          element={<CardTransactionDetailPage />}
        />
        <Route
          path={RoutesString.CardTransactionDetail}
          element={<CardTransactionDetailPage />}
        />
        <Route
          path={RoutesString.CardLimitSettingWithId}
          element={<CardLimitSettingPage />}
        />
        <Route
          path={RoutesString.CardLimitSetting}
          element={<CardLimitSettingPage />}
        />
        <Route
          path={RoutesString.CardStatementWithId}
          element={<CreditCardStatementPage />}
        />
        <Route
          path={RoutesString.CardStatement}
          element={<CreditCardStatementPage />}
        />
        <Route
          path={RoutesString.CardStatementView}
          element={<CreditCardStatementViewPage />}
        />
        <Route
          path={RoutesString.CardPaymentWithId}
          element={<CreditCardPaymentPage />}
        />
        <Route
          path={RoutesString.CardPayment}
          element={<CreditCardPaymentPage />}
        />
        <Route
          path={RoutesString.CardPaymentConfirm}
          element={<CreditCardPaymentConfirmPage />}
        />
        <Route
          path={RoutesString.CardUnlockWithId}
          element={<CardUnlockPage />}
        />
        <Route
          path={RoutesString.CardUnlock}
          element={<CardUnlockPage />}
        />
        <Route
          path={RoutesString.CardLockWithId}
          element={<CardLockPage />}
        />
        <Route path={RoutesString.CardLock} element={<CardLockPage />} />
        <Route
          path={RoutesString.CardOnlinePaymentWithId}
          element={<CardOnlinePaymentPage />}
        />
        <Route
          path={RoutesString.CardOnlinePayment}
          element={<CardOnlinePaymentPage />}
        />
        <Route
          path={RoutesString.CardActionResult}
          element={<CardActionResultPage />}
        />
        {/* TERM_DEPOSIT */}
        <Route
          path={RoutesString.TermDepositForm}
          element={<TermAndCondition />}
        />
        <Route
          path={`${RoutesString.TermDepositDetail}/:id`}
          element={<TermDepositDetail />}
        />
        <Route
          path={`${RoutesString.FinalizeDeposit}`}
          element={<FinalizeDeposit />}
        />
        <Route
          path={`${RoutesString.FinalizeDeposit}/:id`}
          element={<FinalizeDepositDetail />}
        />
        <Route
          path={`${RoutesString.WithdrawAccount}`}
          element={<WithdrawAccount />}
        />
        <Route
          path={`${RoutesString.RootWithdrawal}`}
          element={<RootWithdrawal />}
        />
        <Route
          path={`${RoutesString.WithdrawAccountResponse}`}
          element={<WithdrawAccountResponse />}
        />
        <Route
          path={`${RoutesString.ApproveFinalSettlement}`}
          element={<ApproveFinalSettlement />}
        />
        <Route
          path={`${RoutesString.ApproveFinalSettlementResponse}`}
          element={<ApproveFinalSettlementResponse />}
        />
        {/* TERM_LOAN */}
        <Route path={RoutesString.TermCosumerLoan} element={<TermLoan />} />
        <Route
          path={RoutesString.TermDepositSettlement}
          element={<TermDepositSettlement />}
        />
        <Route
          path={RoutesString.TermLoanSettlement}
          element={<LoanSettlement />}
        />
        <Route
          path={RoutesString.TermLoanSettlementResponse}
          element={<TermLoanSettlementResponse />}
        />
        {/* CARDS */}
        <Route path={RoutesString.CardsList} element={<CardList />} />
        {/* <Route
          path={RoutesString.AccountsDetailWithId}
          element={<AccountDetail />}
        /> */}
        {/* <Route
          path={RoutesString.AccountsDetailWithId}
          element={<CurrentAccountPanelDetail />}
        /> */}
        {/* Current Account Detail */}
        <Route
          path="/accounts/detail-current-account/:id"
          element={<CurrentAccountPanelDetail />}
        />
        {/* Deposit Account Detail */}
        <Route
          path="/accounts/detail-deposit-account/:id"
          element={<DepositAccountPanelDetail />}
        />
        {/* Loan Account Detail */}
        <Route
          path="/accounts/detail-loan-account/:id"
          element={<LoanAccountPanelDetail />}
        />
        {/* PAYMENTS */}
        <Route path={RoutesString.BillPayment} element={<BillPayment />} />
        <Route path={RoutesString.Notifications} element={<Notfications />} />
        {/* CREDIT */}
        <Route path={RoutesString.Disbursement} element={<Disbursement />} />
        <Route
          path={RoutesString.AddDisbursement}
          element={<AddDisbursement />}
        />
        <Route
          path={RoutesString.DisbursementDetail}
          element={<DisbursementDetail />}
        />
        {/* Quản lý tiền vay */}
        <Route path={RoutesString.LoanList} element={<LoanManagementList />} />
        <Route
          path={RoutesString.LoanDetail}
          element={<LoanManagementDetail />}
        />
          <Route
            path={RoutesString.LoanClosure}
            element={<LoanManagementClosure />}
          />
          <Route
            path={RoutesString.LoanPayment}
            element={<LoanManagementPayment />}
          />
        {/* OTHER */}
        <Route path={RoutesString.NotFound} element={<NotFound />} />
        {/* <Route path="/chat" element={<ChatPage />} /> */}
        {/* THANH TOÁN HÓA ĐƠN */}
        <Route
          path={RoutesString.BillPaymentList}
          element={<BillPaymentList />}
        />
        <Route
          path={RoutesString.BillPaymentList}
          element={<BillPaymentList />}
        />
        {/* Mua ngoại tệ (URL buy-foreign-currency) — render đúng luồng MUA.
            Lưu ý: 2 module FX bị đặt tên ngược nên element & path đổi chéo nhau. */}
        <Route
          path={RoutesString.ForeignCurrencyExchangePage}
          element={<SellForeignCurrencyPage />}
        />
        {/* Thuế */}
        <Route
          path={RoutesString.DomesticTaxPaymentPage}
          element={<DomesticTaxPaymentPage />}
        />
        <Route
          path={RoutesString.CustomsDutyPaymentPage}
          element={<CustomsDutyPaymentPage />}
        />
        {/* Bán ngoại tệ (URL sell-foreign-currency) — render đúng luồng BÁN. */}
        <Route
          path={RoutesString.SellForeignCurrencyPage}
          element={<ForeignCurrencyExchangePage />}
        />
        <Route
          path={RoutesString.LetterOfCreditPage}
          element={<LetterOfCreditPage />}
        />
        <Route
          path={RoutesString.LetterOfCreditDetailPage}
          element={<LetterOfCreditDetailPage />}
        />

        <Route
          path={RoutesString.ShippingDocumentsPage}
          element={<ShippingDocumentsPage />}
        />
        <Route
          path={RoutesString.ShippingDocumentsDetail}
          element={<ShippingDocumentsDetail />}
        />

        <Route path={RoutesString.GuaranteePage} element={<GuaranteePage />} />
        <Route
          path={RoutesString.GuaranteeDetailPage}
          element={<GuaranteeDetailPage />}
        />
        <Route
          path={RoutesString.GuaranteeIssuancePage}
          element={<GuaranteeIssuancePage />}
        />

        {/* Bảo lãnh dự thầu (AW122) */}
        <Route
          path={RoutesString.GuaranteeListAw122Page}
          element={<GuaranteeListAw122Page />}
        />
        <Route
          path={RoutesString.GuaranteeRequestDetailPage}
          element={<GuaranteeRequestDetailPage />}
        />
        <Route
          path={RoutesString.GuaranteeApprovalListPage}
          element={<GuaranteeApprovalListPage />}
        />
        <Route
          path={RoutesString.GuaranteeApprovePage}
          element={<GuaranteeApprovePage />}
        />
        <Route
          path={RoutesString.GuaranteeLetterDetailPage}
          element={<GuaranteeLetterDetailPage />}
        />
        <Route
          path={RoutesString.GuaranteeIssueStep1Page}
          element={<GuaranteeIssueStep1Page />}
        />
        <Route
          path={RoutesString.GuaranteeIssueStep2Page}
          element={<GuaranteeIssueStep2Page />}
        />        <Route
          path={RoutesString.GuaranteeIssueStep3Page}
          element={<GuaranteeIssueStep3Page />}
        />
        <Route
          path={RoutesString.GuaranteeIssueStep4Page}
          element={<GuaranteeIssueStep4Page />}
        />
        <Route
          path={RoutesString.GuaranteeIssueResultPage}
          element={<GuaranteeIssueResultPage />}
        />
        <Route
          path={RoutesString.GuaranteeSupplementPage}
          element={<GuaranteeSupplementPage />}
        />
        <Route
          path={RoutesString.RegistartionFreePage}
          element={<RegistartionFreePage />}
        />
        <Route
          path={RoutesString.NopNsnnOverview}
          element={<NopNsnnOverviewPage />}
        />
        <Route
          path={RoutesString.MortgageLoanAccountPage}
          element={<MortgageLoanAccountPage />}
        />
        <Route
          path={RoutesString.ConvenienceServicesPage}
          element={<ConvenienceServicesPage />}
        />
        {/* Quản trị doanh nghiệp - CHECKER only */}
        <Route
          path={RoutesString.RequirementsManagementPage}
          element={<GuardedRequirementsManagement />}
        />
        <Route
          path={`${RoutesString.RequirementsManagementPage}/:approvalId`}
          element={<GuardedRequirementsManagement />}
        />
        <Route
          path={RoutesString.UserManagementPage}
          element={<GuardedUserManagement />}
        />
        <Route
          path={RoutesString.InfoBusinessPage}
          element={<GuardedInfoBusiness />}
        />
        <Route
          path={RoutesString.PermissionManagementPage}
          element={<GuardedPermissionManagement />}
        />

        <Route path={RoutesString.BookingList} element={<BookingList />} />
        {/* LC & Thanh toán Quốc tế */}
        <Route
          path={RoutesString.LetterOfCreditOpenedPage}
          element={<LetterOfCreditOpenedPage />}
        />
        <Route
          path={RoutesString.LetterOfCreditOnlinePage}
          element={<LetterOfCreditOnlinePage />}
        />
        <Route
          path={RoutesString.TermDepositList}
          element={<TermDepositListPage />}
        />
        <Route
          path={`${RoutesString.TermDetail}/:accountNo`}
          element={<TermDepositDetailPage />}
        />
        <Route path={RoutesString.ListSavings} element={<SavingListPage />} />
        <Route path={RoutesString.LockDetail} element={<LockDetail />} />
        <Route
          path={RoutesString.LockCheckerDetail}
          element={<ApprovelLockAccountChecker />}
        />
        <Route
          path={RoutesString.DepositSettlement}
          element={<DepositSettlementPage />}
        />
        <Route
          path={RoutesString.PartialWithdrawal}
          element={<PartialWithdrawalPage />}
        />
        <Route
          path={RoutesString.DepositTopupPage}
          element={<DepositTopupPage />}
        />
        <Route
          path={`${RoutesString.TransHistoryDetail}/:transId`}
          element={<TransHistoryDetailPage />}
        />
        <Route
          path="*"
          element={<Navigate replace to={RoutesString.NotFound} />}
        />
      </Route>
    </>,
  ),
);

export default router;
